<template>
  <div id="app">
    <NuxtPage />
  </div>
  <Footer />
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped>
@import "@/assets/styles/App.css";
</style>
